// extracted by mini-css-extract-plugin
export default {"auth_form":"AuthForm_auth_form__9yDTl","errorMessage":"AuthForm_errorMessage__N2Vo3","errorIcon":"AuthForm_errorIcon__VI3QQ","button_login":"AuthForm_button_login__+ng-I"};